export default __webpack_public_path__ + "static/media/post6.16a16c7d.jpg";